//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { MediaFilterParamKey } from '@apis/content-library/contentLibraryApiModel';

export interface FilterSection<T extends FilterValue> {
  options: FilterOption<T>[];
  paramKey: MediaFilterParamKey;
}

export interface FilterOption<T extends FilterValue> {
  isSelected: boolean;
  label: string;
  trackingId?: string;
  value: T;
}

export interface NestedFilterOption<T extends FilterValue>
  extends FilterOption<T> {
  isEnabled: boolean;
  subOptions?: FilterOption<T>[];
}

export type FilterValue = string | number | boolean;

export const FilterSectionTitle: Record<MediaFilterParamKey, string> = {
  campaignSubTypes: '',
  campaignTypes: 'Campaigns',
  createdAfter: '',
  dateRange: 'Date Range',
  distribution: 'Distributed to',
  // PD-301894: Remove excludeTargetedRetailerCampaigns and excludeNonTargetedRetailerCampaigns
  excludedContentSources: '',
  excludeNonTargetedRetailerCampaignItems: '',
  excludeTargetedRetailerCampaignItems: '',
  filter: '',
  hasLabels: 'Labels',
  hasProducts: 'Product Tags',
  igHashtags: 'Hashtags',
  igUsernames: 'Usernames',
  includeMissingMedia: '',
  instagramMentionedUsernames: '',
  isDistributed: 'Distribution',
  isRepresentativeItem: '',
  isScheduled: '',
  itemId: '',
  itemTypes: '',
  labels: 'Labels',
  manualModerationMediaStatus: '',
  mediaItemTypes: 'Media Type',
  minuteOffsetRange: '',
  networks: 'Platforms',
  orientation: 'Orientation',
  platforms: 'Platforms',
  productIds: 'Product Tagged',
  reelModerationStatus: '',
  rejectionType: 'Moderation Rejection Type',
  rightsStatuses: 'Rights',
  searchText: '',
  semanticTags: 'Visual Tags',
  spamFiltering: 'Spam Filtering',
  userIds: '',
  videoDuration: 'Video Duration',
};
